// src/lib/modules/SpecialCollections/SpecialCollectionDetails/SpecialCollectionActionMenu.js

import { EditButton } from "@components/backoffice/buttons/EditButton";
// import { NewButton } from '@components/backoffice/buttons/NewButton';
import {
  ScrollingMenu,
  ScrollingMenuItem,
} from "@components/backoffice/buttons/ScrollingMenu";
import { BackOfficeRoutes } from "@routes/urls";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { Divider } from "semantic-ui-react";
import { SpecialCollectionDeleteModal } from "../SpecialCollectionDeleteModal";

export default class SpecialCollectionActionMenu extends Component {
  render() {
    const { specialCollection, relations, offset } = this.props;

    if (!specialCollection || !specialCollection.metadata) {
      return null;
    }

    return (
      <div className="bo-action-menu">
        <EditButton
          fluid
          to={BackOfficeRoutes.specialCollectionEditFor(
            specialCollection.metadata.pid
          )}
          text="Edit Collection"
        />

        <SpecialCollectionDeleteModal
          relations={relations}
          specialCollection={specialCollection}
        />

        <Divider horizontal>Navigation</Divider>

        <ScrollingMenu offset={offset}>
          <ScrollingMenuItem
            elementId="special-collection-summary"
            label="Collection Overview"
          />
          <ScrollingMenuItem
            elementId="special-collection-metadata"
            label="Collection Details"
          />
          <ScrollingMenuItem
            elementId="special-collection-content"
            label="Collection Items"
          />
          <ScrollingMenuItem
            elementId="special-collection-statistics"
            label="Statistics"
          />
        </ScrollingMenu>
      </div>
    );
  }
}

SpecialCollectionActionMenu.propTypes = {
  relations: PropTypes.object,
  specialCollection: PropTypes.object.isRequired,
  offset: PropTypes.number,
};

SpecialCollectionActionMenu.defaultProps = {
  relations: {},
  offset: 0,
};
